// src/components/auth/LoginBox.jsx
//
// RE-VESTIDO em 09/09 — Entrada.dc.html (tela `login`) e
// handoff/11-prompt-telas-entrada.md § 1.
//
// SÓ O DESENHO MUDOU. `tryLogin` está letra por letra como estava: mesma
// validação de CPF, mesma `checkCpfStatus`, mesmo `startVerification`, mesmos
// `setStep`/`setActiveTab`, mesmas mensagens. Nenhum nome de prop, estado,
// evento ou rota foi tocado.
//
// A tela agora é: metade de cima com o halo pulsando, o logo e o wordmark
// LES|VITA; metade de baixo em folha de canto 34 com o CPF e o botão
// gradiente. O amarelo saiu — aqui o destaque é azul.

import React, { useState } from "react";
import Style from "../../styles/components/auth/Entrada.module.scss";
import Loader from "../../design/components/Loader/Loader";
import { getFunctions, httpsCallable } from "firebase/functions";
import { sendEmailCode } from "../../utils/sendEmailCode";
import { formatCPF, validateCpfWithMessage, sanitizeCpf } from "../../utils/cpf";
import { callFirebaseFunction } from "../../utils/firebaseFunctionCaller";
import Politicas from '../../pages/politicas/PagePoliticas'
import Offcanvas from "../common/SwipeableOffcanvas.jsx";
import MarcaEntrada from "./MarcaEntrada.jsx";

const LoginBox = ({
  cpf,
  setCpf,
  setActiveTab,
  setCodigoVerificacao,
  setStep,
  setMensagemSistema,
  setFormData,
  mensagemSistema,
  setConfirmationResult,
  setSessionId,
  setHint,
  setVerifyPayload,
}) => {
  const [loading, setLoading] = useState(false);
  const [erroValidacao, setErroValidacao] = useState("");
  const functions = getFunctions(undefined, "southamerica-east1");
  const [showOffcanvas, setShowOffcanvasPoliticas] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    setCpf(formatCPF(value));
    setErroValidacao("");
  };

  const gerarCodigo = () => Math.floor(100000 + Math.random() * 900000).toString();

  const tryLogin = async () => {
    const erro = validateCpfWithMessage(cpf);
    if (erro) {
      setErroValidacao(erro);
      return;
    }

    setLoading(true);
    setErroValidacao("");
    setMensagemSistema("");

    try {
      const cpfSemPontuacao = sanitizeCpf(cpf);
      const data = await callFirebaseFunction("checkCpfStatus", { cpf: cpfSemPontuacao });
      const { status, email, contato } = data || {};

      switch (status) {
        case 'exists':
          try {
              const loginPayload = { mode: "login", cpf: cpfSemPontuacao };
              const data = await callFirebaseFunction("startVerification", loginPayload);

            if (data.status === 'sent') {
              // Guarda o payload para permitir o reenvio do código na tela OTP.
              if (setVerifyPayload) setVerifyPayload(loginPayload);
              setSessionId(data.sessionId);
              setHint(data.hint);
              setConfirmationResult({ cpf: cpf });
              setStep(2);
            } else {
              throw new Error("Falha ao iniciar a verificação.");
            }
          } catch (verificationError) {
            console.error("Erro ao chamar startVerification:", verificationError);
            setMensagemSistema("Não foi possível enviar o código de verificação. Tente novamente.");
          }
          break;

        case 'not_found':
          setMensagemSistema("CPF não encontrado, realize o cadastro.");
          setFormData((prev) => ({ ...prev, CPF: cpf }));
          setActiveTab("cadastro");
          setStep(1);
          break;

        case 'excluded':
          setMensagemSistema("Este CPF está com solicitação de exclusão ativa. A conta será removida em até 60 dias.");
          setErroValidacao("Entre em contato com suporte@lesvita.com");
          break;

        default:
          setMensagemSistema("Ocorreu um erro inesperado. Tente novamente.");
          break;
      }
    } catch (error) {
      console.error("Erro ao chamar a função checkCpfStatus:", error);
      setMensagemSistema(error.message || "Erro ao conectar com o servidor. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={Style.tela}>
      <span className={Style.fundoLogin} aria-hidden="true" />

      <MarcaEntrada />

      <div className={Style.folha}>
        <span className={Style.puxador} aria-hidden="true" />
        <h1 className={Style.titulo}>Entrar na conta</h1>

        {mensagemSistema && <p className={Style.aviso}>{mensagemSistema}</p>}

        <div className={Style.campo}>
          <label className={Style.rotulo} htmlFor="login-cpf">CPF</label>
          <input
            id="login-cpf"
            className={Style.entrada}
            type="tel"
            name="CPF"
            value={cpf}
            onChange={handleChange}
            onKeyDown={(e) => e.key === "Enter" && tryLogin()}
            maxLength={14}
            placeholder="000.000.000-00"
            inputMode="numeric"
            autoComplete="username"
          />
          {erroValidacao && <p className={Style.erro}>{erroValidacao}</p>}
        </div>

        <button
          type="button"
          className={Style.primario}
          onClick={tryLogin}
          id="nextButton"
          disabled={loading}
        >
          {loading ? <Loader tamanho={28} /> : "Avançar"}
        </button>

        <p className={Style.troca}>
          Ainda não tem conta?
          <button
            type="button"
            className={Style.trocaLink}
            onClick={() => setActiveTab("cadastro")}
          >
            Cadastre-se
          </button>
        </p>
      </div>

      <Offcanvas show={showOffcanvas} onHide={() => setShowOffcanvasPoliticas(false)} placement="end">
        <Offcanvas.Body>
          <Politicas />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default LoginBox;
